import { api } from "@/shared/libs/axiosClient";
import { CalendarTokenResponse, CurrentUserResponse, GoogleAuthRequest, GoogleAuthResponse } from "@/shared/types";

/**
 * Google OAuth 토큰으로 백엔드 인증
 * @param request Google OAuth token
 * @returns 백엔드 JWT 토큰과 사용자 정보
 */
export async function loginWithGoogle(
  request: GoogleAuthRequest
): Promise<GoogleAuthResponse> {
  return api.post<GoogleAuthResponse>("/auth/google", request);
}

/**
 * 현재 로그인된 사용자 정보 조회
 * @returns 사용자 정보
 */
export async function getCurrentUser(): Promise<CurrentUserResponse> {
  return api.get<CurrentUserResponse>("/me");
}

export async function getCalendarToken(): Promise<CalendarTokenResponse> {
  return api.get<CalendarTokenResponse>("/me/calendar-token");
}

export async function generateCalendarToken(): Promise<CalendarTokenResponse> {
  return api.post<CalendarTokenResponse>("/me/calendar-token");
}
